<template v-if="isLoggedIn">
    <div class="container-fluid page" v-if="authToken!==''">

        <div class="card card-default" style="min-width:420px">
            <div class="card-header">
                <div class="row">
                    <div class="col-sm-6 font-weight-bold">
                        <h5>Dashboard Reports</h5>
                    </div>
                </div>

            </div>
            <div class="card-body">
                The Dashboard Reports will open in a new tab or window.<br />
                <small>Note: Your browser may require permission to open a form in a new window</small>
            </div>
        </div>

        
        <form ref="formLogin" id="formLogin" action="https://reports.therewardsfactory.com/sso/reportauth" method="post" target="_blank">
            <input type="hidden" name="authToken" :value="authToken" />
        </form>

        <!--<script language="javascript" type="text/javascript">setTimeout(function(){document.getElementById('dashboardForm').submit();}, 250);</script>-->

        <div v-if="isLoading"><i>Loading...</i></div>

    </div>

   
</template>

<script>
    // @ is an alias to /src
    import axios from 'axios'
    import sjData from '@/sjUtilData'


    export default {
        name: 'ReportDashboard',
        data() {
            return {
                authToken: ''
            }
        },
        computed: {
            member() {
                return this.$store.state.memberStore.member
            },

            isLoggedIn() {
                return this.$store.state.isLoggedIn
            },




        },

        created() {
            
        },
        mounted() {
            this.loadReport();
        },
        watch: {
            
        },

        methods: {
            loadReport() {
                this.isLoading = true;
                this.report = [];
                const theRefs = this.$refs;

                axios.post('/api/report/reportdashboardguid', {})
                    .then(({ data }) => {
                        this.isLoading = false;
                        this.authToken = data.authToken;

                        //nextTick(() => {
                            setTimeout(function () {
                                console.log('Redirecting to dashboard', data.authToken)
                                theRefs.formLogin.submit(); //vue 2
                                //formLogin.value.submit();
                            }, 500);
                       // });

                        //setTimeout(function () {
                        //    console.log('Redirecting to dashboard', data.authToken)
                        //    //let f = document.getElementById('dashboardForm');
                        //    //debugger;
                        //    //f.submit();
                        //    this.$refs.formLogin.submit();
                        //}, 250);
                    })
                    .catch((error) => {
                        this.isLoading = false;
                        console.error("reportdashboardguid", error);
                        if (error) {
                            this.msgBox(JSON.stringify( error));
                        }
                    })
            },
            
            msgBox(msg, title) {
                this.$bvModal.msgBoxOk(msg, { title: typeof title === 'undefined' ? 'Please note:' : title, centered: true })
            },
            


        }

    }
</script>
